import {
    ADD_REVIEW_DETAIL_SUCCESS,
    ADD_REVIEW_DETAIL_ERROR
  } from "Constant";
  
  const initialState = {
    loading: false,
    data:null
      
  };
  
  export default function AddReviewDataReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case ADD_REVIEW_DETAIL_SUCCESS:
        return {
          ...state,
          loading: true,
        };
      case ADD_REVIEW_DETAIL_ERROR:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      default:
        return state;
    }
  }
  